module.exports = __webpack_public_path__ + "static/media/mq.02d2f0be.svg";